"use strict";

exports.__esModule = true;
var _HasAccess = require("./HasAccess");
Object.keys(_HasAccess).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _HasAccess[key]) return;
  exports[key] = _HasAccess[key];
});